<template>
  <div class="container">
    <router-view name="header"></router-view>
      <router-view></router-view>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import "./fonts/font.css";
.container{
  height: auto;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue